import { render, staticRenderFns } from "./ExtraGames.vue?vue&type=template&id=633676dc&"
import script from "./ExtraGames.vue?vue&type=script&lang=js&"
export * from "./ExtraGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports